module.exports = __webpack_public_path__ + "ed8466e00c6fe3db1fc5efedd989ec25.svg";